import React, { useState, useEffect } from "react";
import { useMode } from "@/contexts/ModeContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";
import MedicationInfoDialog from "./MedicationInfoDialog";
import { inputMethodsConfig } from "./config/inputMethodsConfig";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { EntryMethodCard } from "./entry-methods/EntryMethodCard";
import { ManualEntryCard } from "./entry-methods/manual/ManualEntryCard";

export function MedicationEntryTabs() {
  const { expandedSection, setExpandedSection } = useMode();
  const [showAllOptions, setShowAllOptions] = useState(false);
  const { toast } = useToast();
  const { getItem, setItem } = useLocalStorage();

  const toggleSection = (section: string) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const recordMethodUsage = (methodId: string) => {
    setItem("lastUsedMethod", methodId);
  };

  // Get the configured input methods with their components
  const [inputMethods, setInputMethods] = useState(() =>
    inputMethodsConfig
      .filter(method => method.id !== "voice") //Filter out voice input
      .map((method) => ({
        ...method,
        recordMethodUsage,
        toast,
        toggleSection,
      }))
  );

  useEffect(() => {
    const lastUsed = getItem("lastUsedMethod");
    if (lastUsed) {
      const lastUsedMethod = inputMethods.find((method) => method.id === lastUsed);
      if (lastUsedMethod) {
        // Place the last used method at the top of the array
        const reorderedMethods = [
          lastUsedMethod,
          ...inputMethods.filter((method) => method.id !== lastUsed),
        ];
        setInputMethods(reorderedMethods);
      }
    }
  }, []);

  // Secondary Methods Section
  const SecondaryMethods = () => (
    <div className="space-y-2">
      {inputMethods.slice(0, showAllOptions ? inputMethods.length : 2).map((method, index) => (
        <EntryMethodCard
          key={method.id}
          method={method}
          isExpanded={expandedSection === method.id}
          toggleSection={toggleSection}
        />
      ))}
    </div>
  );

  return (
    <Card className="w-full max-w-4xl mx-auto p-4 md:p-6 space-y-4 md:space-y-6 shadow-sm border-gray-100">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl md:text-2xl font-semibold mb-1">
            Add Medications in less than 2 mins
          </h2>
           {/* 
          <p className="text-gray-500 text-sm">
            Choose your preferred method to add medications
          </p>
          */}
        </div>
        <MedicationInfoDialog />
      </div>

      {/* The "Free to start" and "Private and secure" banner has been moved to the hero section */}

      <div className="space-y-6">
        <ManualEntryCard
          isExpanded={expandedSection === "manual"}
          toggleSection={() => toggleSection("manual")}
        />

        {/* Secondary methods section has been hidden */}
      </div>
    </Card>
  );
}